import { css } from "@emotion/css";
import { Key, useContext } from "react";

import { AccordionGroupContext } from "./AccordionGroup";

export interface AccordionGroupPanelProps {
  id: Key;
  children: React.ReactNode;
}

export function AccordionGroupPanel({
  id,
  ...props
}: AccordionGroupPanelProps) {
  const { isOpen } = useContext(AccordionGroupContext);

  return (
    <div className={styles.wrapper}>
      <div className={css({ width: "100%" })}>
        {/* ^ extra div required for 100% max-height animation */}
        <div
          data-open={isOpen(id)}
          aria-hidden={isOpen(id)}
          className={styles.panel}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: css({ display: "flex" }),
  panel: css({
    "&[data-open=false]": {
      maxHeight: "0",
      opacity: "0",
    },
    "&[data-open=true]": {
      maxHeight: "100%",
      opacity: "1",
    },
    overflow: "hidden",
    transition: "all 0.2s ease-out",
  }),
};
